window.addEventListener("load", () => {
    globalThis.ret.initContentTooltips(".js-info-tooltip-init", {
        placement: "top",
        arrow: false,
    });
});
